import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'
import { useState } from 'react'
import Link from 'components/common/A'
import CursorBox from 'components/common/CursorPointerBox.js'
import Logo from './Logo'
import { GtmAgent } from 'utils/hooks/analytics'
import { setVenderViewedOrClicked } from 'utils/api'
import { getVenderWelcomeInfo } from 'utils/helpers/vender-welcome-info'
import { getVenderJoinedYears } from 'utils/helpers/vender-joined-years'

export const ArticleKeywordWrapper = styled(Typography)`
  // 子元素保持原本的寬度，不被壓縮
  & > * {
    flex-shrink: 0;
  }
  display: -webkit-box;
  webkitboxorient: vertical;
  overflow: hidden;
  line-height: 1.5em;
  max-height: 1.5em;
`

const StyleCursorBox = styled(CursorBox)`
  ${({ theme, isLarge }) => `
    border-bottom: 1px solid ${theme.palette.grey.secondary};
    padding:  ${isLarge ? '24px 0' : '16px 0'};
  `}
  display: flex;
  flex-direction: column;
`

const VenderListItem = ({ vender, isLarge, filterState }) => {
  const [onHover, setOnHover] = useState(false)
  const { logoImage, favorableDiscountText } = getVenderWelcomeInfo(vender)
  const joinedYears = getVenderJoinedYears(
    vender?.introductionInfo?.joinedSinyiLivingDate
  )
  const venderInfoLabels = [
    ...(joinedYears >= 1 ? [`已加入信義居家 ${joinedYears} 年`] : []),
    ...(vender?.ownQualityTag?.qualityTags || []).map((tag) => tag.name),
  ]

  const sendVenderGTM = async (vender, filterState) => {
    try {
      GtmAgent.directSendToGTM({
        event: 'living_action',
        living_event_name: 'select_vender',
        living_vender: vender?.name || '',
        living_vender_county: (
          vender?.introductionInfo?.serviceCounties || []
        ).join('、'),
        living_vender_service: (
          vender.venderServiceItems.map(
            (item) => item.serviceClassification.name
          ) || []
        ).join('、'),
        living_filter_county: filterState?.serviceCounty || '',
        living_filter_service: filterState?.serviceClassificationName || '',
      })
    } catch (error) {
      console.error('Error fetching services:', error)
    }
  }

  return (
    <Link
      href={`/vender/${vender?.urlId}${
        filterState.serviceItem ? `?serviceItem=${filterState.serviceItem}` : ''
      }`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        sendVenderGTM(vender, filterState)
        setVenderViewedOrClicked(vender._id, { isAddClick: true })
      }}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <StyleCursorBox isLarge={isLarge}>
        <Box display="flex" gap={2} alignItems="center">
          <Logo
            img={logoImage?.url}
            name={vender?.shortname}
            isLarge={isLarge}
          />
          <Box
            display="flex"
            gap={1}
            flexDirection="column"
            alignItems="start"
            sx={{ typography: 'bodyXs' }}
          >
            <Typography
              variant={isLarge ? 'headlineSmall' : 'titleLarge'}
              color={onHover ? 'text.minus2' : 'text.minus1'}
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 2,
              }}
            >
              <Box fontWeight="fontWeightBold">{vender?.shortname}</Box>
            </Typography>
            <ArticleKeywordWrapper variant="body2" color="text.secondary">
              {venderInfoLabels.map((label, index) => (
                <Box display="inline-block" key={index}>
                  <Typography variant={isLarge ? 'bodySmall' : 'bodyXs'}>
                    {index > 0 && '・'}
                    {label}
                  </Typography>
                </Box>
              ))}
            </ArticleKeywordWrapper>
          </Box>
        </Box>
        {vender?.venderServiceItems?.length > 0 && (
          <Typography
            variant="paraBodyMedium"
            color="text.minus1"
            mt={isLarge ? 4 : 2}
          >
            {vender?.venderServiceItems
              .map((item) =>
                item?.serviceClassification?.isVenderFilterListVisible
                  ? item?.serviceClassification?.name
                  : null
              )
              .filter(Boolean)
              .join(' / ')}
          </Typography>
        )}

        {!!favorableDiscountText && (
          <Box p={2} mt={isLarge ? 2 : 1} bgcolor="primary.bgPlus2">
            <Typography
              variant="labelLarge"
              color="text.minus2"
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 1,
              }}
            >
              特色優惠
              <Box
                component="span"
                sx={{ typography: 'bodySmall' }}
                color="text.minus1"
                fontWeight="fontWeightRegular"
                ml={1}
              >
                {favorableDiscountText}
              </Box>
            </Typography>
          </Box>
        )}
      </StyleCursorBox>
    </Link>
  )
}

export default VenderListItem
